// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgetPasswordOtp_form__ipAJg {
  display: flex;
  padding: 18px;
  flex-direction: column;
  align-items: flex-start;
  min-height: 250px;
  width: 100%;
}

.forgetPasswordOtp_backIcon__1PkZ7 {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 12px 0;
  margin-bottom: 32px;
}
.forgetPasswordOtp_backIcon__1PkZ7::before {
  content: "\\e92d";
  font-size: 2rem;
  cursor: pointer;
}

.forgetPasswordOtp_title__Qcenw {
  color: var(--color-black);
  font-weight: 700;
  font-size: 1.66rem;
  line-height: 24px;
}

.forgetPasswordOtp_mobile__MgoCU {
  line-height: 24px;
  font-size: 1.14rem;
  color: var(--color-grey-1);
  margin-bottom: 10px;
  margin-top: 20px;
}

.forgetPasswordOtp_formContainer__Zo-NJ {
  font-size: 0.857rem;
  line-height: 21px;
  color: #62666d;
  width: 100%;
  margin-bottom: 32px;
}

.forgetPasswordOtp_row__qHCJv {
  display: flex;
  flex-direction: row-reverse;
}

.forgetPasswordOtp_input__9-8a\\+ {
  padding: 12px;
  text-align: center !important;
  border-radius: 8px;
  direction: ltr;
  background-color: var(--z-input-bg);
  border: 1px solid var(--z-input-border);
  font-size: 1.166rem;
  line-height: 16px;
  width: 100%;
  height: 40px;
  line-height: normal;
  color: var(--z-input-color);
  -webkit-appearance: none;
}
.forgetPasswordOtp_input__9-8a\\+::placeholder {
  color: var(--z-input-color);
  opacity: 0.8;
}
.forgetPasswordOtp_input__9-8a\\+:focus {
  border: 2px solid var(--z-input-border);
}

.forgetPasswordOtp_action__5yyAK {
  width: 100%;
}

.forgetPasswordOtp_verifyBtn__ZYF8b {
  width: 100%;
}

.forgetPasswordOtp_timerContainer__yuf-r {
  display: flex;
  justify-content: center;
  font-size: 1.14rem;
  line-height: 24px;
  color: var(--color-grey-1);
  padding: 8px;
  width: 100%;
  margin-bottom: 32px;
}

.forgetPasswordOtp_resendBtn__1R4Ml {
  cursor: pointer;
}
.forgetPasswordOtp_resendBtn__1R4Ml:hover {
  color: var(--dg-primary-color);
  text-decoration: underline;
}

.forgetPasswordOtp_error__iQdqq {
  margin: 10px 0 0 !important;
}

.forgetPasswordOtp_counter__rg0Gt {
  margin: 0 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginSignUp/ForgetPassword/components/forgetPasswordOtp.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AACD;;AACA;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAED;AAAC;EACC,gBAAA;EACA,eAAA;EACA,eAAA;AAEF;;AACA;EACC,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAED;;AAAA;EACC,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;AAGD;;AADA;EACC,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;AAID;;AAFA;EACC,aAAA;EACA,2BAAA;AAKD;;AAHA;EACC,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,mCAAA;EACA,uCAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;AAMD;AAJC;EACC,2BAAA;EACA,YAAA;AAMF;AAJC;EACC,uCAAA;AAMF;;AAHA;EACC,WAAA;AAMD;;AAJA;EACC,WAAA;AAOD;;AALA;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAQD;;AANA;EACC,eAAA;AASD;AAPC;EACC,8BAAA;EACA,0BAAA;AASF;;AANA;EACC,2BAAA;AASD;;AAPA;EACC,aAAA;AAUD","sourcesContent":[".form {\n\tdisplay: flex;\n\tpadding: 18px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tmin-height: 250px;\n\twidth: 100%;\n}\n.backIcon {\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: center;\n\tpadding: 12px 0;\n\tmargin-bottom: 32px;\n\n\t&::before {\n\t\tcontent: '\\e92d';\n\t\tfont-size: 2rem;\n\t\tcursor: pointer;\n\t}\n}\n.title {\n\tcolor: var(--color-black);\n\tfont-weight: 700;\n\tfont-size: 1.66rem;\n\tline-height: 24px;\n}\n.mobile {\n\tline-height: 24px;\n\tfont-size: 1.14rem;\n\tcolor: var(--color-grey-1);\n\tmargin-bottom: 10px;\n\tmargin-top: 20px;\n}\n.formContainer {\n\tfont-size: 0.857rem;\n\tline-height: 21px;\n\tcolor: #62666d;\n\twidth: 100%;\n\tmargin-bottom: 32px;\n}\n.row {\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n}\n.input {\n\tpadding: 12px;\n\ttext-align: center !important;\n\tborder-radius: 8px;\n\tdirection: ltr;\n\tbackground-color: var(--z-input-bg);\n\tborder: 1px solid var(--z-input-border);\n\tfont-size: 1.166rem;\n\tline-height: 16px;\n\twidth: 100%;\n\theight: 40px;\n\tline-height: normal;\n\tcolor: var(--z-input-color);\n\t-webkit-appearance: none;\n\n\t&::placeholder {\n\t\tcolor: var(--z-input-color);\n\t\topacity: 0.8;\n\t}\n\t&:focus {\n\t\tborder: 2px solid var(--z-input-border);\n\t}\n}\n.action {\n\twidth: 100%;\n}\n.verifyBtn {\n\twidth: 100%;\n}\n.timerContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n\tfont-size: 1.14rem;\n\tline-height: 24px;\n\tcolor: var(--color-grey-1);\n\tpadding: 8px;\n\twidth: 100%;\n\tmargin-bottom: 32px;\n}\n.resendBtn {\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: var(--dg-primary-color);\n\t\ttext-decoration: underline;\n\t}\n}\n.error {\n\tmargin: 10px 0 0 !important;\n}\n.counter {\n\tmargin: 0 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `forgetPasswordOtp_form__ipAJg`,
	"backIcon": `forgetPasswordOtp_backIcon__1PkZ7`,
	"title": `forgetPasswordOtp_title__Qcenw`,
	"mobile": `forgetPasswordOtp_mobile__MgoCU`,
	"formContainer": `forgetPasswordOtp_formContainer__Zo-NJ`,
	"row": `forgetPasswordOtp_row__qHCJv`,
	"input": `forgetPasswordOtp_input__9-8a+`,
	"action": `forgetPasswordOtp_action__5yyAK`,
	"verifyBtn": `forgetPasswordOtp_verifyBtn__ZYF8b`,
	"timerContainer": `forgetPasswordOtp_timerContainer__yuf-r`,
	"resendBtn": `forgetPasswordOtp_resendBtn__1R4Ml`,
	"error": `forgetPasswordOtp_error__iQdqq`,
	"counter": `forgetPasswordOtp_counter__rg0Gt`
};
export default ___CSS_LOADER_EXPORT___;
